module.exports = __webpack_public_path__ + "static/whitepaper_download_market_research-8f3f95517feac98fcea4385c1aa8f4f0.jpg";